export default {
      id: "comp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#comp",
      toString: function () {
        return this.url;
      }
    }